import { render, staticRenderFns } from "./RedirectPostForm.vue?vue&type=template&id=7d15f670&"
import script from "./RedirectPostForm.vue?vue&type=script&lang=js&"
export * from "./RedirectPostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports